import { Box, Typography, useTheme } from "@mui/material";
import styles from "./Window.module.css";

const Window = ({ title, children }) => {
    const theme = useTheme();
    return (
        <Box
            className={styles.container}
            style={{ "--backgroundColor": theme.palette.background.paper }}
        >
            <Box
                className={styles.header}
                style={{
                    "--headerBackgroundColor": theme.palette.primary.main,
                }}
            >
                <Typography variant="h6" fontWeight="bold" color="white">
                    {title}
                </Typography>
            </Box>

            <Box className={styles.content}>{children}</Box>
        </Box>
    );
};

export default Window;
